module.exports = __webpack_public_path__ + "img/03.25d92c6e.png";